<template>
  <div class="status-text">
    <span style="color: #409EFF;" v-if="status == 0">
      <span class="mr15">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-pending"></use>
        </svg>
      </span>
      <span>Pending 準備中</span>
    </span>
    <span style="color:#c810d4;" v-if="status == 1">
      <span class="mr15">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-approved"></use>
        </svg>
      </span>
      <span>Approved 已審核</span>
    </span>
    <span style="color:#d8d108;" v-if="status == 2">
      <span class="mr15">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-processing"></use>
        </svg>
      </span>
      <span>Processing 處理中</span>
    </span>
    <span style="color: #179A16;" v-if="status == 3">
      <span class="mr15">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-success"></use>
        </svg>
      </span>
      <span>Success 已完成</span>
    </span>
    <span style="color: #e95801;" v-if="status == 4">
      <span class="mr15">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-fail"></use>
        </svg>
      </span>
      <span>Fail 失敗</span>
    </span>
    <span style="color: #ccc;" v-if="status == 5">
      <span class="mr15">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-delete"></use>
        </svg>
      </span>
      <span>Deleted 已刪除</span>
    </span>
  </div>
</template>
<script>
export default {
  name: 'statusText',
  props: ['status'],
}
</script>

<style scoped>
.status-text {
  font-size: 16px;
  font-weight: 700;
}
</style>